import { useAnalytics } from '../../../core/Analytics/AnalyticsProvider';
import { ApplicationEvent } from '../../../models/analytics';
import { ProviderField } from '../../../models/provider';
import { Button } from '../../atoms/Button/Button';
import { SubmitProviderInputsPayload } from '../../screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { TemplateElementType } from '../templates';

export type MaybeChangeMethodButtonProps = {
  elements: ProviderField[];
  onSubmit: (values: SubmitProviderInputsPayload) => void;
};

export const MaybeChangeMethodButton: React.FC<MaybeChangeMethodButtonProps> = ({
  elements,
  onSubmit,
}) => {
  const { tinklinkAnalytics } = useAnalytics();

  const changeMethodElement = elements.find(
    (elm) => elm.type === TemplateElementType.CHANGE_METHOD
  );

  const handleChangeMethod = () => {
    onSubmit({
      CHANGE_METHOD: 'true',
    });
    tinklinkAnalytics.sendApplicationEvent(ApplicationEvent.TEMPLATE_CHANGE_METHOD);
  };

  if (!changeMethodElement) {
    return null;
  }

  return (
    <Button data-testid="change-authentication-method" onClick={handleChangeMethod}>
      {changeMethodElement.value}
    </Button>
  );
};
